import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../components/Login.vue";
import Pedidos from "../components/Pedidos.vue";
import PedidosForm from "../components/PedidosForm.vue";
import Clientes from "../components/Clientes.vue";
import Produtos from "../components/Produtos.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/pedidos",
    name: "Pedidos",
    component: Pedidos,
  },
  {
    path: "/pedidos/adicionar",
    name: "PedidosAdicionar",
    component: PedidosForm,
  },
  {
    path: "/pedidos/editar",
    name: "PedidosEditar",
    component: PedidosForm,
  },
  {
    path: "/clientes",
    name: "Clientes",
    component: Clientes,
  },
  {
    path: "/produtos",
    name: "Produtos",
    component: Produtos,
  },
  {
    path: "/*",
    name: "NotFount",
    redirect: "/",
    component: Home,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
